/* eslint-disable
    @typescript-eslint/no-this-alias,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import { Analytics } from '@trello/atlassian-analytics';

import { Auth } from 'app/scripts/db/Auth';
import { templates } from 'app/scripts/views/internal/templates';
import { View } from 'app/scripts/views/internal/view';
import { PopOver } from 'app/scripts/views/lib/PopOver';
import { CreateOrgView } from 'app/scripts/views/organization/CreateOrgView';
import { PopoverHelperNewBoardAddOrgTemplate } from 'app/scripts/views/templates/PopoverHelperNewBoardAddOrgTemplate';
import { stopPropagationAndPreventDefault } from 'app/src/stopPropagationAndPreventDefault';

interface NewBoardHelperAddOrgView {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  $el: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  model: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  modelCache: any;
}

// @ts-expect-error TS(2707): Generic type 'View<TOptions, TModel>' requires bet... Remove this comment to see the full error message
class NewBoardHelperAddOrgView extends View {
  static initClass() {
    // @ts-expect-error TS(2339): Property 'viewTitleKey' does not exist on type 'Ne... Remove this comment to see the full error message
    this.prototype.viewTitleKey = 'add an organization';

    // @ts-expect-error TS(2339): Property 'events' does not exist on type 'NewBoard... Remove this comment to see the full error message
    this.prototype.events = { 'click .js-create-org': 'newOrg' };
  }

  render() {
    this.$el.html(templates.fill(PopoverHelperNewBoardAddOrgTemplate));

    Analytics.sendScreenEvent({
      name: 'newBoardHelperAddWorkspaceInlineDialog',
    });
    return this;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  newOrg(e: any) {
    const createOpts = {};

    if (Auth.me().isPaidManagedEntMember()) {
      // @ts-expect-error TS(2339): Property 'isEnterprise' does not exist on type '{}... Remove this comment to see the full error message
      createOpts.isEnterprise = true;
    }

    stopPropagationAndPreventDefault(e);
    const trackingOpts = {
      category: 'board',
      method: 'by clicking team info icon in copy board menu',
    };
    return PopOver.pushView({
      view: new CreateOrgView({
        model: this.model,
        modelCache: this.modelCache,
        createOpts,
        trackingOpts,
      }),
    });
  }
}

NewBoardHelperAddOrgView.initClass();
export { NewBoardHelperAddOrgView };
